module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "m-show": _vm.successShow
    }
  }, [_c('div', {
    staticClass: "beast-login-warp register"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": require("./assets/close.png")
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('p', {
    staticClass: "r-success-title"
  }, [_vm._v("注册成功")]), _vm._v(" "), _c('p', {
    staticClass: "r-success-tips"
  }, [_vm._v("你获得了BEAST 野兽派的居民证！")])]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "forget-tips"
  }, [_c('img', {
    staticClass: "passport",
    attrs: {
      "src": require("./assets/passport.png"),
      "height": "752",
      "width": "576",
      "alt": ""
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5a0f86"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-login/register-success.vue
// module id = 130
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 20 21 22 24 25 26 29 31 32 33 34 35 37 38 41 42 43 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63